module.exports = __webpack_public_path__ + "static/media/DSC_6845-HDR.ba94f3d0.jpg";